<template>
    <form @change="sendDataForSaving">
        <div class="row">
            <ValidationProvider style="margin-bottom: 10px"
                                 name="Question 1"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">1) As a security officer, you may encounter an emergency
                        situation. Explain what you would do if you see fire while on the job. What is the first
                        thing you would do? Who would you contact?</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_1"></textarea>
                    <FormError :error="errors[0]" name="Question 1"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider style="margin-bottom: 10px"
                                 name="Question 2"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">2) What would you do if a fire panel in the building lobby
                        alerts you of a fire?</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_2"></textarea>
                    <FormError :error="errors[0]" name="Question 2"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider style="margin-bottom: 10px"
                                 name="Question 3"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">3) You have been assigned to a lobby of a large condo and it is
                        3:00am on a Friday morning. A resident walks in to the lobby extremely drunk, falls and hits
                        his head on the lobby floor. What should you do?</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_3"></textarea>
                    <FormError :error="errors[0]" name="Question 3"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider style="margin-bottom: 10px"
                                 name="Question 4"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">4) While on rover patrol, you notice 6 teenagers in the pool
                        area after the pool was closed for the day. What would you do?</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_4"></textarea>
                    <FormError :error="errors[0]" name="Question 4"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider style="margin-bottom: 10px"
                                 name="Question 5"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">5) While on duty at the gatehouse, a man on a bicycle rides
                        right through the gate without stopping. What should you do?</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_5"></textarea>
                    <FormError :error="errors[0]" name="Question 5"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider style="margin-bottom: 10px"
                                 name="Question 6"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">6) If someone is rude to me, I will respond by</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_6"></textarea>
                    <FormError :error="errors[0]" name="Question 6"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider style="margin-bottom: 10px" name="Question 7"
                                 rules="required|latinAndNumbers|min:2|max:500" v-slot="{ errors }"
                                 class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">7) While on duty you receive a phone call and the caller says,
                        “I am the owner, someone is coming to pick up a package which is locked in the manager’s
                        office” and tells you to break the door down and get inside, what will you do in this
                        situation?</label>
                    <textarea type="text" class="form-control height-2" v-model="form.question_7"></textarea>
                    <FormError :error="errors[0]" name="Question 7"></FormError>
                </div>
            </ValidationProvider>
            <div class="col-md-12">
                <p>
                    <b>Applicant: Please read the following:</b> <br/>
                    This is to inform you that a background investigation will be conducted as part of your
                    pre-employment processing.
                </p>
                <p>
                    I AUTHORIZE all former employers, listed references, law enforcement agencies and courts, credit
                    bureaus, academic institutions, or other sources of information pertaining to me to release and
                    deliver such information upon request to Screening Link acting on behalf of ORNA.
                </p>
                <p>
                    I AUTHORIZE ORNA to conduct a criminal history search, and other background checks already
                    enumerated above or as otherwise required, through Screening Link.
                </p>
                <p>
                    I understand that employment with ORNA or any of its affiliates or subsidiaries is contingent
                    upon successful completion of the pre-employment background investigation. I acknowledge that if
                    I provide false, inaccurate, incomplete or misleading information it may result in my being
                    terminated at a future date.
                </p>
                <p>
                    I also release ORNA its affiliates, subsidiaries, employees, trustees and agents from any and
                    all claims and liability related to or arising from my pre-employment background investigation.
                    I further release any and all parties providing information in connection with my pre-employment
                    background investigation from any and all claims and liability related to or arising there from,
                    and all such parties are authorized to provide any information requested by ORNA in connection
                    with the pre-employment background investigation and to rely on this release as if they were a
                    party hereto.
                </p>
                <p>
                    I understand I may request access to the results of the criminal record checks conducted in
                    connection with this background investigation and that I will be given an opportunity to address
                    any findings that would negatively impact upon my being offered employment.
                </p>
            </div>
            <ValidationProvider style="margin-bottom: 10px" name="Arrests" rules="latinAndNumbers|min:2|max:500"
                                 v-slot="{ errors }" class="col-lg-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Please indicate all arrests and convictions on this
                        page.</label>
                    <input type="text" class="form-control" v-model="form.arrests">
                    <FormError :error="errors[0]" name="Arrests"></FormError>
                </div>
            </ValidationProvider>

            <div class="col-lg-12" v-if="!isMasterAdmin">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">By checking the I agree button below I certify that all the
                        information is true and correct to the best of my knowledge. </label>
                    <div class="form-group form-group-1">

                        <ValidationProvider name="I certify that all the
                        information is true and correct"
                                            rules="required"
                                            v-slot="{ errors }" class="form-check">
                            <input class="form-check-input-checkbox" type="radio"
                                   name="name12"
                                   id="office-office"
                                   v-model="form.agree" value="1">
                            <label class="form-check-label" for="office-office">
                                I AGREE
                            </label>
                            <FormError :error="errors[0]" name="I certify that all the
                        information is true and correct"></FormError>
                        </ValidationProvider>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>

export default {
    name: 'AdditionalQuestionsForm',
    props: {
        user: {
            type: Object
        },
        isMasterAdmin: Boolean
    },
    emits:['data-changed'],
    data() {
        return {
            form: {
                question_1: null,
                question_2: null,
                question_3: null,
                question_4: null,
                question_5: null,
                question_6: null,
                question_7: null,
                arrests: null,
                agree: null,
            },
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        setData() {
            for (const userKey in this.user.additional_question) {
                for (const formKey in this.form) {
                    if (userKey === formKey) {
                        this.form[userKey] = this.user.additional_question[formKey];
                    }
                }
            }
        },
    },
    mounted() {
        this.setData()
    }
}

</script>

<style scoped>

</style>
